<script setup lang="ts">
import BuilderSumsub from '~/components/user-interface/dynamic-form/builder-sumsub.vue';
import type { SumsubComponentProps } from '~/interfaces/components/sumsub';
import { ESumSubAction } from '~/interfaces/dto/compliance/request';
import GenericError from '~/components/user-interface/generic-error.vue';

const { $enabled } = useNuxtApp();

const error = ref<string | boolean>(false);

const model = defineModel({ type: Boolean, default: false });
const props = withDefaults(defineProps<SumsubComponentProps>(), {
  unauthenticatedToken: '',
  action: ESumSubAction.None,
  externalEvaluation: false,
});

const emits = defineEmits<{
  (e: 'complete'): void;
  (e: 'error', error: string): void;
}>();

const sumSubEnabled = computed(
  () => $enabled('security.sumsubenabled') || false,
);
const displaySumSub = computed(
  () => model.value && sumSubEnabled.value && !error.value,
);

function completeProcess() {
  emits('complete');
  model.value = false;
}

watchEffect(() => {
  if (!!error.value) {
    emits('error', `${error}`);
    model.value = false;
  }
});

watch(
  () => model.value,
  (value) => {
    if (!!value) error.value = null;
  },
);
</script>

<template>
  <div>
    <GenericError v-if="!!error && displayError" class="my-2">
      {{ $t(`sumsub-${error}`) }}
    </GenericError>
    <div v-show="!displaySumSub">
      <slot />
    </div>
    <BuilderSumsub
      v-if="displaySumSub"
      v-bind="props"
      :key="pregeneratedToken"
      @complete="completeProcess()"
      @error="
        (err) => {
          if (displayError) {
            error = err;
            emits('error', err);
          }
        }
      "
    />
  </div>
</template>

<style scoped lang="scss"></style>
